<template>
  <!-- htmlファイル側の「<router-view>」内に表示する内容 -->
   <!-- ここに結果を表示 -->
   
   <h2 class="vy-kojin-title">{{ title }}</h2>
     <article style="padding:0 10px">
            <hr>
            <!-- パンくずリスト -->
            <nav style="--bs-breadcrumb-divider: '>';" aria-label="breadcrumb" >
                <ol class="breadcrumb">
                    <li class="breadcrumb-item"><a href="#" v-on:click="Return_home">Home</a></li>
                    <li class="breadcrumb-item"><a href="#" v-on:click="Return_list">体験プログラム一覧</a></li>
                    <li class="breadcrumb-item" v-if="program_id != 0"><a href="#" v-on:click="Return_detail">体験プログラム詳細</a></li>
                    <li class="breadcrumb-item active" aria-current="page">{{ title }}</li>
                </ol>
            </nav>
            <div id="manual_area">
<!--
              <span v-on:click="manual_open"><img class="m_icon" src="../../images/mark/manual.png"  />体験ユーザーのマニュアル</span>-->
              <span v-on:click="qanda_open"><img class="m_icon" src="../../images/mark/QandA.png"  />システムQ&A</span>

            </div>

            <br clear="all">

      <div id="detail_button_area">
        <span v-if="Unconfirmed_flg">
            <button style="width: 200px; height: 50px;padding: 0;margin:5px;background-color:green" class="btn btn-secondary mx-aut" v-on:click="alert_clear()">アラートを解除する</button>
        </span>
      </div><br>

      <div id="tab">
        
        <ul class="tabMenu">
                
                <li @click="TabSelect(1)" id="tab1" v-bind:class="color1">
                  申込者一覧
                  <span class="balloon_parent">
                    <img class="q_icon" src="../../images/mark/qmark.png"  />
                    <span class="balloon-top" style="min-width:450px;left:-225px" >
                      プログラムに参加している体験ユーザーの一覧を表示します。
                    </span>
                  </span>
                </li>
                <li @click="TabSelect(2)" id="tab2" v-bind:class="color2">
                  キャンセル履歴
                  <span class="balloon_parent">
                    <img class="q_icon" src="../../images/mark/qmark.png"  />
                    <span class="balloon-top" style="min-width:400px;left:-200px" >
                      プログラムがキャンセルされた日時が記録されます。
                    </span>
                  </span>
                </li>
                <li @click="TabSelect(8)" id="tab8" v-bind:class="color8">
                  申込者メッセージ
                  <span class="balloon_parent">
                    <img class="q_icon" src="../../images/mark/qmark.png"  />
                    <span class="balloon-top" style="min-width:450px;left:-225px" >
                      体験ユーザーからメッセージが送られた日時が記録されます。
                    </span>
                  </span>
                </li>
                
            </ul>

            <!-- 申込者一覧・キャンセルの場合 -->
        <template v-if="kubun == 1 || kubun == 2">

          <div style="width: 98%;text-align: left;padding-top: 10px;margin-left: 10px;">
            <b>プログラムNo.：</b>{{ taiken_program.taiken_no_text }}<br>
            <b>プログラム名 ：</b>{{ taiken_program.name }}<br>
            <b>活動内容     ：</b>{{ taiken_program.naiyou }}<br>
          </div><br>

          <div class="tabContents">

            <table v-if="!isSP" style="width:100%;margin:10px 0">
              <tr style="background-color: orange;">
                <td width="5%">No.</td>
                <td width="25%">開催日時</td>
                <td width="28%">氏名</td>
                <td width="5%">性別</td>
                <td width="5%">年齢</td>
                <td width="12%">体験者区分</td>
                <td width="15%">申込日時</td>
                <!--  とりあえず要らない   実績からデータを取得しているので、受入先確認フラグは、取得できない。Moushikomi_getAPIで履歴管理テーブルを取得する¥ように修正しなければいけない。
                <td width="5%">確認</td>
                -->
              </tr>
              <!-- 「table」内でv-forを使うときは「template」で囲む -->
              <template v-for="(result,i) in results" v-bind:key="i">

                <tr style="text-align: left;">
                  <td style="text-align: center;" v-on:click="ShakyoTaikenuserDetail(result.taikenuser_id)">
                    {{ i+1 }}
                  </td>
                  <td style="text-align: center;" v-on:click="ShakyoTaikenuserDetail(result.taikenuser_id)">
                    {{ MessageTimestamp_ymd(result.kaisai_date)+" "+MessageTimestamp_hour(result.kaisai_date+" "+result.jikantai_start)+"～"+MessageTimestamp_hour(result.kaisai_date+" "+result.jikantai_end) }}
                  </td>
                  <td v-on:click="ShakyoTaikenuserDetail(result.taikenuser_id)">
                    {{ result.username }}
                  </td>
                  <td style="text-align: center;" v-on:click="ShakyoTaikenuserDetail(result.taikenuser_id)">
                    {{ result.usersex }}
                  </td>
                  <td style="text-align: center;" v-on:click="ShakyoTaikenuserDetail(result.taikenuser_id)">
                    {{ getAge(result.userbirth) }}歳
                  </td>
                  <td style="text-align: center;" v-on:click="ShakyoTaikenuserDetail(result.taikenuser_id)">
                    {{ result.shokugyo_kbn==0?"学生":"一般" }}
                  </td>
                  <td style="text-align: center;" v-on:click="ShakyoTaikenuserDetail(result.taikenuser_id)">
                    {{ MessageTimestamp(result.moshikomi_date) }}
                  </td>
                  <!--  とりあえず要らない   実績からデータを取得しているので、受入先確認フラグは、取得できない。Moushikomi_getAPIで履歴管理テーブルを取得する¥ように修正しなければいけない。
                  <td style="text-align: center;" v-on:click="ShakyoTaikenuserDetail(result.taikenuser_id)">
                    {{ result.facility_check==0?"":"済" }}
                  </td>
                  -->
                </tr>
                
              </template>

            </table>
            <table v-if="isSP" style="width:100%;margin:10px 0;">
              <template v-for="(result,i) in results" v-bind:key="i">
                <tr>
                  <td style="padding:2pt 6pt;background-color:orange;border-bottom: 1px solid #FFF;justify-content: flex-start;align-items: center;">
                    <div style="display: flex;align-items: center;">
                      <div style="width: 30%;text-align: left;"><b>開催日時</b></div>
                      <div style="width: 70%;text-align: left;">
                        {{ MessageTimestamp_ymd(result.kaisai_date)+" "+MessageTimestamp_hour(result.kaisai_date+" "+result.jikantai_start)+"～"+MessageTimestamp_hour(result.kaisai_date+" "+result.jikantai_end) }}
                      </div>
                    </div>
                  </td>
                </tr>  
                <tr>
                  <td style="padding:2pt 6pt;background-color:linen;justify-content: flex-start;align-items: center;" border="1">
                    <div style="display: flex;align-items: center;">
                      <div style="width: 30%;text-align: left;"><b>氏名</b></div>
                      <div style="width: 70%;text-align: left;">{{ result.username }}</div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td style="padding:2pt 6pt;background-color:linen;justify-content: flex-start;align-items: center;" border="1">
                    <div style="display: flex;align-items: center;">
                      <div style="width: 30%;text-align: left;"><b>性別</b></div>
                      <div style="width: 70%;text-align: left;">{{ result.usersex }}</div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td style="padding:2pt 6pt;background-color:linen;justify-content: flex-start;align-items: center;" border="1">
                    <div style="display: flex;align-items: center;">
                      <div style="width: 30%;text-align: left;"><b>年齢</b></div>
                      <div style="width: 70%;text-align: left;">{{ getAge(result.userbirth) }}歳</div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td style="padding:2pt 6pt;background-color:linen;justify-content: flex-start;align-items: center;" border="1">
                    <div style="display: flex;align-items: center;">
                      <div style="width: 30%;text-align: left;"><b>体験者区分</b></div>
                      <div style="width: 70%;text-align: left;">{{ result.shokugyo_kbn==0?"学生":"一般" }}</div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td style="padding:2pt 6pt;background-color:linen;justify-content: flex-start;align-items: center;" border="1">
                    <div style="display: flex;align-items: center;">
                      <div style="width: 30%;text-align: left;"><b>申込日時</b></div>
                      <div style="width: 70%;text-align: left;">{{ MessageTimestamp(result.moshikomi_date) }}</div>
                    </div>
                  </td>
                </tr>
                <!--  とりあえず要らない   実績からデータを取得しているので、受入先確認フラグは、取得できない。Moushikomi_getAPIで履歴管理テーブルを取得する¥ように修正しなければいけない。
                <tr>
                  <td style="padding:2pt 6pt;background-color:linen;justify-content: flex-start;align-items: center;" border="1">
                    <div style="display: flex;align-items: center;">
                      <div style="width: 30%;text-align: left;"><b>確認</b></div>
                      <div style="width: 70%;text-align: left;">{{ result.facility_check==0?"":"確認済" }}</div>
                    </div>
                  </td>
                </tr>
                -->
                <br>

              </template>

            </table>

          </div>

      </template>

        <!-- メッセージの場合 -->
        <template v-if="kubun == 8">

          <div style="width: 98%;text-align: left;padding-top: 10px;margin-left: 10px;">
            <b>プログラムNo.：</b>{{ taiken_program.taiken_no_text }}<br>
            <b>プログラム名 ：</b>{{ taiken_program.name }}<br>
            <b>活動内容     ：</b>{{ taiken_program.naiyou }}<br>
          </div><br>

          <div class="vy-search-result-row-head" style="width:98%;margin:auto" >
            
              <div class="vy-search-result-column-kojin-head-name" style="width:20%">
                氏名
              </div>
              <div class="vy-search-result-column-kojin-head-exp" style="width:20%">
                メッセージタイトル
              </div>
              <div class="vy-search-result-column-kojin-head-exp" style="width:45%">
                メッセージ内容
              </div>
              <div class="vy-search-result-column-kojin-head-ins" style="width:15%">
                日時
                <span class="sort_button">
                  <a href="#" v-on:click.prevent.stop="Sort('toroku_timestamp')">{{ date_order }}</a>
<!--
                  <a href="#" v-on:click.prevent.stop="Sort('toroku_timestamp','ASC')">↑</a>
                  <a href="#" v-on:click.prevent.stop="Sort('toroku_timestamp','DESC')">↓</a>
-->
                </span>
              </div>
              
          </div>
          <div class="vy-search-result" style="width:98%;margin:auto auto 10px auto;">
            <!--
            <div v-for="(result) in display_results" v-bind:key="result.user_id" class="vy-search-result-row">-->
            <!--<div v-for="(katsu,i) in katsudo.slice(st-1,ed-1)" v-bind:key="i">-->
            <div v-for="(result,i) in disp_results" v-bind:key="i" class="vy-search-result-row">
              
              <div class="vy-search-result-row-a" style="cursor: default;">
                  
                  <div class="vy-search-result-column-kojin-name" style="width:20%" v-on:click="Read_message_shosai(result)">
                    {{result.username}}
                  </div>
                  <div class="vy-search-result-column-kojin-exp" style="width:20%" v-on:click="Read_message_shosai(result)">
                    {{result.message_title}}
                  </div>
                  <div class="vy-search-result-column-kojin-exp" style="width:45%" v-on:click="Read_message_shosai(result)">
                    {{result.message_honbun}}
                  </div>
                  
                  <div class="vy-search-result-column-kojin-ins" style="width:15%" v-on:click="Read_message_shosai(result)">
                  {{ MessageTimestamp(result.toroku_timestamp) }}
                  </div>
                
              </div>
            </div>
          </div>
        </template>

        
        <template v-if="kubun == 3">

          <div style="width: 98%;text-align: left;padding-top: 10px;margin-left: 10px;">
            <b>プログラムNo.：</b>{{ taiken_program.taiken_no_text }}<br>
            <b>プログラム名 ：</b>{{ taiken_program.name }}<br>
            <b>活動内容     ：</b>{{ taiken_program.naiyou }}<br>
          </div><br>

          <div class="vy-search-result-row-head" style="width:98%;margin:auto" >
            
              <div class="vy-search-result-column-kojin-head-name" style="width:60%">
                氏名
              </div>
              <div class="vy-search-result-column-kojin-head-ins" style="width:40%">
                日時
                <span class="sort_button">
                  <a href="#" v-on:click.prevent.stop="Sort('toroku_timestamp')">{{ date_order }}</a>
<!--
                  <a href="#" v-on:click.prevent.stop="Sort('toroku_timestamp','ASC')">↑</a>
                  <a href="#" v-on:click.prevent.stop="Sort('toroku_timestamp','DESC')">↓</a>
--> 
                </span>
              </div>
              
          </div>
          <div class="vy-search-result" style="width:98%;margin:auto auto 10px auto;">
            <!--
            <div v-for="(result) in display_results" v-bind:key="result.user_id" class="vy-search-result-row">-->
            <!--<div v-for="(katsu,i) in katsudo.slice(st-1,ed-1)" v-bind:key="i">-->
            <div v-for="(result,i) in disp_results" v-bind:key="i" class="vy-search-result-row">
              
              <div class="vy-search-result-row-a" style="cursor: default;" >
                  
                  <div class="vy-search-result-column-kojin-name" style="width:60%" v-on:click="Read_shosai(result)">
                    {{result.username}}
                  </div>
                  
                  <div class="vy-search-result-column-kojin-ins" style="width:40%" v-on:click="Read_shosai(result)">
                  {{ Timestamp(result.toroku_timestamp) }}
                  </div>
                
              </div>
            </div>
          </div>

          <!--メッセージを表示するモーダルウィンドウ-->
          <component v-bind:is="contentMessage"
                    v-bind:message_text="message"
                    v-bind:message_cat="message_cat"
                    v-bind:message_flag="message_flag"
                    @close_message="Close_message"
                    @ok_message="OK_message"/>

        </template>
      </div>
    </article>
</template>

<script setup>
/* メッセージを表示するモーダルウィンドウ */
import MessageModal from '../common/MessageModal.vue'  
/* eslint-disable */
import { ref, onMounted, onBeforeUnmount } from 'vue'
import { useRouter,useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { GlobalData } from '../js/userdata_shisetsu.js'

import axios from 'axios'
const router = useRouter();
const route = useRoute()
const store = useStore()
const emit = defineEmits(['call'])

const url = GlobalData.$API_URL

let title = "申込者情報"

// 親コンポーネント（ShakyoUser.vue）から送られてきた値
// param = {'results':response.data.rireki_kanri}
const props = defineProps(['param']);
let results = props.param.results //情報が全件入った配列
let taiken_program = ref([]) // 申込者一覧の時の体験プログラム情報
let kubun = ref(props.param.kubun)
let kensu = ref(0)
let disp_kensu = ref(0)
let program_id = props.param.program_id

let date_order = ref("")

let isSP = ref(window.matchMedia("(max-width: 960px)").matches)

let message = ref("")//表示するメッセージ
let message_cat = ref(0)// メッセージのカテゴリ（0：OKのみ、1：OK or キャンセルの選択式）
let message_method = ref("")// こちら（親コンポーネント）に帰った時、どの処理（関数）を行うのか（message_catが1の時のみ）
let message_flag = ref(false)//表示・非表示フラグ

/* 表示する子コンポーネント関係の情報 */
const contentMessage = ref(null)// 表示する子コンポーネントの情報（メッセージ表示エリア）

const cityname = route.params.shakyo
const facility = route.params.shisetsu
// 未確認フラグ
let Unconfirmed_flg = ref(false)

if(props.param.rireki_mode == undefined){
  date_order.value = "▲"
} else if(props.param.rireki_mode == "ASC"){
  date_order.value = "▲"
} else {
  date_order.value = "▼"
}

let disp_results = ref([])

// 1件でも存在する場合は、全実績の配列から件数を取得し、未チェックインとチェックイン済に分ける
if(results[0]){
 
  disp_results.value = results

  kensu.value = results.length
  disp_kensu.value = disp_results.value.length

}

let TabActive = ref("") // どのタブを選択しているか

// タブ部分の背景色を切り替えるためのクラス
let color1 = ref("tabwhite")
let color2 = ref("tabwhite")
let color8 = ref("tabwhite")

let all_check = ref(false) // 申込者一覧のメール送信対象者チェックボックス（全て）

// 申込者一覧のチェックされたユーザー
let user_check = ref([])

let get_taiken_program_error =  0
let get_taiken_program = function(id){  

  let send_array = {"taiken_id":id}

  axios.post(url + "Taiken_read",send_array,GlobalData.$ID_Token)  //ヘッダーを追加（IDトークンを送信）
  .then(response => {

    taiken_program.value = response.data

  })
  .catch(error => {

    if(get_taiken_program_error == 6){
        message.value = error + GlobalData.$axios_error;
        message_method.value = "change_error";
        message_cat.value = 0;
        message_flag.value = true;
        contentMessage.value = MessageModal
    }else{
        get_taiken_program_error++
        setTimeout(function(){get_taiken_program(id)},"1000")
    }
        
  })
}

if(kubun.value == 1){
  taiken_program.value = props.param.taiken_program // 申込者一覧の時の体験プログラム情報
} else {
  get_taiken_program(program_id)
}

/* 親コンポーネントに関わる関数 */

let Read_shosai = function(result){  
  return    // 今は使わない

  let rireki_id = result.rireki_kanri_id
  let user_id = result.user_id
  
  Rireki_update(rireki_id)
  // ユーザーの参加状況へ
  router.push('/'+GlobalData.shakyo+'/Kanri/User/jyokyotaiken/'+user_id+'/'+program_id+'/?taiken_rireki')
}

// 既読フラグを立てる
let Rireki_update = function(rireki_id){
  
  // 親コンポーネントへ更新命令を送る
  emit('call',{cmd:'rireki_update',rireki_id:rireki_id});
}

// メッセージの情報を元に確認を行う
let Read_message_shosai = function(result){  
  return  // 今は使わない
  let user_id = result.taikenuser_id

  Rireki_message_update(user_id)
  // ユーザーの参加状況へ
  router.push('/'+GlobalData.shakyo+'/Kanri/User/jyokyotaiken/'+user_id+'/'+program_id+'/?taiken_rireki')
}

// メッセージの情報を元に既読フラグを立てる
let Rireki_message_update = function(user_id){
  
  // 親コンポーネントへ更新命令を送る
  emit('call',{cmd:'rireki_message_update',program_id:program_id,user_id:user_id});
}



let Tabdisp = function(select_kubun){
    TabActive.value = "tab"+kubun

    color1.value = "tabwhite"
    color2.value = "tabwhite"
    color8.value = "tabwhite"
    if(select_kubun == 1){
      color1.value = "tabblue"
    }else if(select_kubun == 2){
      color2.value = "tabblue"
    }else if(select_kubun == 8){
      color8.value = "tabblue"

    }

}

// 項目を並び替える
let Sort = function(komoku){ 
  let mode = ""
  if(date_order.value == "▲"){
    mode = "DESC"
    date_order.value = "▼"
  } else {
    mode = "ASC"
    date_order.value = "▲"
  }
  // 親コンポーネントへ、並び替えたい項目と昇順・降順の指定を送る
  emit('call',{cmd:'rireki_search',order:komoku,mode:mode});
}

// タブをクリックしたときの処理
let TabSelect = function(select_kubun){
  // 親コンポーネントへ切替命令を送る
  emit('call',{cmd:'rireki_search',rireki_kubun:select_kubun});
}

/* コンポーネントの表示に関わる処理 */
let Return_home = function(){
    
    router.push("/"+GlobalData.shakyo+"/"+route.params.shisetsu+"/Shisetsu")
}

// パンくずリストのクリックで履歴コンポーネントから検索コンポーネントに戻す
let Return_list = function(){
    router.push("/"+GlobalData.shakyo+"/"+route.params.shisetsu+"/Shisetsu")
}

// パンくずリストのクリックで履歴コンポーネントから詳細コンポーネントに戻す
// ※体験ユーザーIDが0以外（＝詳細コンポーネントからこの画面が開かれている）場合のみ表示
let Return_detail = function(){
  router.push("/"+GlobalData.shakyo+"/"+route.params.shisetsu+"/Shisetsu/detail/"+program_id)
}


/* その他関数の記述 */
let youbi_list = [ "日", "月", "火", "水", "木", "金", "土" ]
//タイムスタンプから日時を取り出す
let Timestamp = function(timestamp){  
    if(timestamp != "None"){
      let set_date = new Date(timestamp);
      set_date = set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
      set_date = new Date(set_date);
      set_date.setHours(set_date.getHours());

      return (set_date.getMonth()+1)+"月"+set_date.getDate()+"日（"+youbi_list[set_date.getDay()]+"）"+ ('00'+set_date.getHours()).slice(-2)+":"+('00'+set_date.getMinutes()).slice(-2)
    }
}
let MessageTimestamp = function(timestamp){  
    if(timestamp != "None"){
      let set_date = new Date(timestamp);
      set_date = set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
      set_date = new Date(set_date);
      set_date.setHours(set_date.getHours() - 9);

      return (set_date.getMonth()+1)+"月"+set_date.getDate()+"日（"+youbi_list[set_date.getDay()]+"）"+ ('00'+set_date.getHours()).slice(-2)+":"+('00'+set_date.getMinutes()).slice(-2)
    }
}

let MessageTimestamp_ymd = function(timestamp){  
    if(timestamp != "None"){
      let set_date = new Date(timestamp);
      set_date = set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
      set_date = new Date(set_date);
      set_date.setHours(set_date.getHours() - 9);

      return (set_date.getMonth()+1)+"月"+set_date.getDate()+"日（"+youbi_list[set_date.getDay()]+"）"
    }
}

let MessageTimestamp_hour = function(timestamp){  
    if(timestamp != "None"){
      let set_date = new Date(timestamp);
      set_date = set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
      set_date = new Date(set_date);
      set_date.setHours(set_date.getHours());

      // return ('00'+set_date.getHours()).slice(-2)+":"+('00'+set_date.getMinutes()).slice(-2)
      return set_date.getHours() + ":" + String(set_date.getMinutes()).padStart(2, '0')
    }
}

// 誕生日から、年齢を取得する
let getAge = function(birthday){

  if(birthday){
    //今日
    var today = new Date();
    var set_birthday = birthday.split("-");

    //今年の誕生日
    var thisYearsBirthday = new Date(today.getFullYear(), set_birthday[1]-1, set_birthday[2]);

    //年齢
    var age = today.getFullYear() - set_birthday[0]

    if(today < thisYearsBirthday){
        //今年まだ誕生日が来ていない
        age--;
    }

  // getSchoolGrade(birthday)

  return age;
  }
}

// 申込者一覧のすべてチェックにチェックしたとき
let all_user_check = function(){
  user_check.value = []
    if(all_check.value == false){
      
      for(let r = 0;r<results.length;r++){
        user_check.value[user_check.value.length] = results[r].taikenuser_id
      }
    }
}

let Mail_send = function(){
  
  if(user_check.value.length == 0){
    alert("メールを送信したいユーザーが選択されていません。")
  }else{
    // 親コンポーネントへ、メール送信ウィンドウを開くよう命令する
    emit('call',{cmd:'mail_send',syurui:1,program_id:taiken_program.taiken_id,user_id:user_check.value});
  }
}

let ShakyoTaikenuserDetail = function(u_id){
  return    // 今は使わないが将来使うかも
  router.push('/'+GlobalData.shakyo+'/Kanri/User/detail/'+u_id)
}

//---------------- 申込み・申込み取消し未確認のチェック
let alert_clear_error = 0
let alert_clear = function(){
    // program_id,program_kbn,kubunは、検索キー 他はアップデート
    let param = {
        program_id:program_id,
        program_kbn:1,
        kubun:'1,2',
        facility_check:1
    }

    axios.post(url + "Check_Rireki_update",
               param,
               GlobalData.$ID_Token)  //ヘッダーを追加（IDトークンを送信）
    .then(response => {
        if( response.data.status == 1){
            alert("エラーが発生しました。\n"+rt.message)
            return
        }

        alert_message_clear()

      })
    .catch(error => {
        
        if(alert_clear_error == 6){
            message.value = error + GlobalData.$axios_error;
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "alert_clear_error";
            contentMessage.value = MessageModal
        }else{
            alert_clear_error++
            setTimeout(function(){alert_clear()},"1000")
        }
    })

}

//---------------- 申込み・申込み取消し未確認のチェック
let alert_message_clear_error = 0
let alert_message_clear = function(){
    // program_id,program_kbn,kubunは、検索キー 他はアップデート
    let param = {
        program_id:program_id,
        facility_check:1
    }

    axios.post(url + "Check_MessageRireki_update",
               param,
               GlobalData.$ID_Token)  //ヘッダーを追加（IDトークンを送信）
    .then(response => {
        if( response.data.status == 1){
            alert("エラーが発生しました。\n"+rt.message)
            return
        }

        emit('call',{cmd:'rireki_search',rireki_kubun:kubun.value});

        // router.push("/"+cityname+"/"+facility+"/Shisetsu/rireki_search/"+program_id)

        // Unconfirmed_flg.value = false
        // アラートのチェックを行う。
        // check_Unconfirmed()

      })
    .catch(error => {
        
        if(alert_message_clear_error == 6){
            message.value = error + GlobalData.$axios_error;
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "alert_clear_error";
            contentMessage.value = MessageModal
        }else{
            alert_message_clear_error++
            setTimeout(function(){alert_message_clear()},"1000")
        }
    })

}

//---------------- 申込み・申込み取消し未確認のチェック
let check_Unconfirmed_error = 0
let check_Unconfirmed = function(){

    let param = {
        choson_code:cityname,
        facility_code:facility,
        taiken_id:program_id,
        program_kbn:1,
        kubun:'1,2'
    }

    axios.post(url + "Check_Rireki_get",
               param,
               GlobalData.$ID_Token)  //ヘッダーを追加（IDトークンを送信）
    .then(response => {

        let  rt = response.data
        if( rt.status == 1){
            alert("エラーが発生しました。\n"+rt.message)
            return
        }
        // 申込み・申込み取消し履歴の未読が１件でもある場合は、「アラートを解除する」ボタンを表示する。
        let r = rt.rireki_data
        for(let i = 0 ; i < r.length ; i++){
          if(r[i].facility_check == 0){
            Unconfirmed_flg.value = true
            break
          }
        }

        check_Message_Unconfirmed()

    })
    .catch(error => {
        
        if(check_Unconfirmed_error == 6){
            message.value = error + GlobalData.$axios_error;
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "check_Unconfirmed_error";
            contentMessage.value = MessageModal
        }else{
            check_Unconfirmed_error++
            setTimeout(function(){check_Unconfirmed()},"1000")
        }
    })

}

//---------------- 申込み者のメッセージ履歴の未確認のチェック
let check_Message_Unconfirmed_error = 0
let check_Message_Unconfirmed = function(){

    let param = {
        choson_code:cityname,
        facility_code:facility,
        taiken_id:program_id
    }

    axios.post(url + "Check_MessageRireki_get",
               param,
               GlobalData.$ID_Token)  //ヘッダーを追加（IDトークンを送信）
    .then(response => {

        let  rt = response.data
        if( rt.status == 1){
            alert("エラーが発生しました。\n"+rt.message)
            return
        }
        // 申込者からのメッセージ履歴の未読が１件でもある場合は、「アラートを解除する」ボタンを表示する。
        let r = rt.rireki_data
        for(let i = 0 ; i < r.length ; i++){
          if(r[i].facility_check == 0){
            Unconfirmed_flg.value = true
            break
          }
        }

    })
    .catch(error => {
        
        if(check_Message_Unconfirmed_error == 6){
            message.value = error + GlobalData.$axios_error;
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "check_Unconfirmed_error";
            contentMessage.value = MessageModal
        }else{
            check_Message_Unconfirmed_error++
            setTimeout(function(){check_Message_Unconfirmed()},"1000")
        }
    })

}

check_Unconfirmed()

let manual_open = function(){
    let url = "https://zest-newsprint-e3e.notion.site/18ac0be34f8f8065a9b2ce0d1a8fc973"
    window.open(url,"_blank")
}

let qanda_open = function(){
    let url = "https://zest-newsprint-e3e.notion.site/Q-A-177c0be34f8f80f08c74c585be043e05"
    window.open(url,"_blank")

}

// 画面がリサイズされた時にＰＣかスマホかの判断をする
const handleResize = () => {
  isSP.value = window.matchMedia("(max-width: 960px)").matches
}

onMounted(() => {
  // リサイズ監視イベント開始
  window.addEventListener('resize', handleResize)
})

onBeforeUnmount(() => {
  // リサイズ監視のイベントを破棄する(メモリーリーク対応)
  window.removeEventListener('resize', handleResize)
})

/* 初期処理 */
Tabdisp(kubun.value)
</script>

<style>
 #tab {
        width: 100%;
        margin: auto;
        border:1px solid #007db9;
    }
  .tabMenu {
    display: flex;
    padding: 0;
    margin-bottom:0;
   }

  .tabMenu li {
      list-style:none;
      width: 50%;
      padding: 10px 20px;
      cursor: pointer;
      border-top:0;
      border-left:0;
      border-right: 1px solid #007db9;
      border-bottom: 1px solid #007db9;
  }

  .tabContents {
    width: 100%;
    padding:0 20px;
    border: 1px solid #007db9;
  }

  .tabContents h2 {
      margin: 0 0 10px 0;
      font-size: 20px;
      font-weight: bolder;
  }

  .tabblue{
      color: #fff;
      background-color: #007db9;
  }
  .tabwhite{
      color: #007db9;
      background-color:#fff ;
  }


#List_button_area{
    width: 100%;
    display: flex;
    justify-content: center;
}

#List_button_area a{
    width: 30%;
    max-width: 200px;
    margin: 10px;
}

.vy-search-result-row-head,.vy-search-result{
 text-align: left; 
}

.vy-search-result-row-a{
  cursor: pointer;
}

.tabblue{
      color: #fff;
      background-color: #007db9;
  }
  .tabwhite{
      color: #007db9;
      background-color:#fff ;
  }
  
</style>


<style scoped>

.balloon_parent:hover .balloon-top2,
.balloon_parent:hover .balloon-top3,
.balloon_parent:hover .balloon-top4,
.balloon_parent:hover .balloon-top-right {
  display: inline;                /* インライン要素として表示 */
}
.balloon-top2 {
  position   : absolute;                /* 親要素を基準 */
  display: none;                        /* 要素を非表示 */
  padding: 10px;                         /* テキストの前後の余白 */
  background-color: rgb(230, 230, 230);       /* 背景色（透明度） */
  left : -65px;                           /* 表示位置 */
  bottom : 100%;                        /* 表示位置 */
  margin-bottom : 12px;                 /* 表示位置 */
  width:auto;                          /* 吹き出し全体の幅 */
  color:black;
  min-width: 350px;
  border:1px solid rgb(230, 230, 230);
  z-index:1;
}
.balloon-top2:after{
  border-top: 12px solid rgb(230, 230, 230);    /* 吹き出し口の高さ・色 */
  border-left: 10px solid transparent;    /* 吹き出し口の幅１／２ */
  border-right: 10px solid transparent;   /* 吹き出し口の幅１／２ */
  bottom: -12px;                          /* 吹き出し口の位置調整 */
  left : 19%;                              /* 吹き出し口の横位置 */
  content: "";                       /* コンテンツの挿入 */
  position: absolute;                /* 親要素を基準 */
}

.balloon-top3 {
  position   : absolute;                /* 親要素を基準 */
  display: none;                        /* 要素を非表示 */
  padding: 10px;                         /* テキストの前後の余白 */
  background-color: rgb(230, 230, 230);       /* 背景色（透明度） */
  left : -300px;                           /* 表示位置 */
  bottom : 100%;                        /* 表示位置 */
  margin-bottom : 12px;                 /* 表示位置 */
  width:auto;                          /* 吹き出し全体の幅 */
  color:black;
  min-width: 500px;
  border:1px solid rgb(230, 230, 230);
  z-index:1;
}
.balloon-top3:after{
  border-top: 12px solid rgb(230, 230, 230);    /* 吹き出し口の高さ・色 */
  border-left: 10px solid transparent;    /* 吹き出し口の幅１／２ */
  border-right: 10px solid transparent;   /* 吹き出し口の幅１／２ */
  bottom: -12px;                          /* 吹き出し口の位置調整 */
  left : 60%;                              /* 吹き出し口の横位置 */
  content: "";                       /* コンテンツの挿入 */
  position: absolute;                /* 親要素を基準 */
}
.balloon-top4 {
  position   : absolute;                /* 親要素を基準 */
  display: none;                        /* 要素を非表示 */
  padding: 10px;                         /* テキストの前後の余白 */
  background-color: rgb(230, 230, 230);       /* 背景色（透明度） */
  left : -300px;                           /* 表示位置 */
  bottom : 100%;                        /* 表示位置 */
  margin-bottom : 12px;                 /* 表示位置 */
  width:auto;                          /* 吹き出し全体の幅 */
  color:black;
  min-width: 350px;
  border:1px solid rgb(230, 230, 230);
  z-index:1;
}
.balloon-top4:after{
  border-top: 12px solid rgb(230, 230, 230);    /* 吹き出し口の高さ・色 */
  border-left: 10px solid transparent;    /* 吹き出し口の幅１／２ */
  border-right: 10px solid transparent;   /* 吹き出し口の幅１／２ */
  bottom: -12px;                          /* 吹き出し口の位置調整 */
  left : 85%;                              /* 吹き出し口の横位置 */
  content: "";                       /* コンテンツの挿入 */
  position: absolute;                /* 親要素を基準 */
}


.balloon-top-right {
  position   : absolute;                /* 親要素を基準 */
  display: none;                        /* 要素を非表示 */
  padding: 10px;                         /* テキストの前後の余白 */
  background-color: rgb(230, 230, 230);       /* 背景色（透明度） */
  right : -20px;                           /* 表示位置 */
  bottom : 100%;                        /* 表示位置 */
  margin-bottom : 12px;                 /* 表示位置 */
  width:auto;                          /* 吹き出し全体の幅 */
  color:black;
  min-width: 520px;
  border:1px solid rgb(230, 230, 230);
  z-index:1;
}
.balloon-top-right:after{
  border-top: 12px solid rgb(230, 230, 230);    /* 吹き出し口の高さ・色 */
  border-left: 10px solid transparent;    /* 吹き出し口の幅１／２ */
  border-right: 10px solid transparent;   /* 吹き出し口の幅１／２ */
  bottom: -12px;                          /* 吹き出し口の位置調整 */
  left : 92%;                              /* 吹き出し口の横位置 */
  content: "";                       /* コンテンツの挿入 */
  position: absolute;                /* 親要素を基準 */
}
</style>